import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";

function HawkeyeInsightPortal(props) {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => setIsMounted(true), []);

  if (isMounted) {
    return ReactDOM.createPortal(props.children, document.querySelector(".hawkeye-story-portal"));
  } else {
    return null;
  }
}

export default HawkeyeInsightPortal;
